"use client";

import { Toaster } from "sonner";
import { useTheme } from "next-themes";

export default function ToastProvider() {
  const { theme } = useTheme();

  return (
    <Toaster
      richColors
      theme={theme === "system" ? "system" : theme}
      position="top-right"
      duration={1500}
    />
  );
}
